/* eslint-disable */
<template>
  <v-card>
    <v-tabs
      fixed-tabs
      next-icon="mdi-arrow-right-bold-box-outline"
      prev-icon="mdi-arrow-left-bold-box-outline"
      show-arrows
    >
      <v-tab>
        Companies
      </v-tab>
      <v-tab>
        Employees
      </v-tab>

      <v-tab-item>
        <v-card v-resize="onResize">
          <v-app-bar
            absolute
            color="white"
            elevation="0"
            scroll-target="#scrolling-techniques-7"
          >
            <v-checkbox
              v-model="selectAll"
              :label="numberSelected"
              @click.stop="selectAllTeam"
              :indeterminate="indeterminate"
              hide-details
            ></v-checkbox>

            <v-toolbar-title class="hidden-sm-and-down ml-5">
              {{ consortium.name }}
            </v-toolbar-title>

            <v-progress-linear
              :active="loading"
              :indeterminate="loading"
              absolute
              bottom
              color="primary"
            ></v-progress-linear>

            <v-spacer></v-spacer>
            <v-tooltip left>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  fab
                  dark
                  small
                  v-bind="attrs"
                  v-on="on"
                  color="primary"
                  @click="editConsortium()"
                >
                  <v-icon>mdi-pencil</v-icon>
                </v-btn>
              </template>
              <span>Edit Consortium</span>
            </v-tooltip>
          </v-app-bar>

          <v-sheet
            v-resize="onResize"
            :height="height"
            id="scrolling-techniques-7"
            class="overflow-y-auto"
          >
            <v-container
              style="margin-top: 70px; margin-bottom: 70px; padding: 0;"
            >
              <v-card class="mx-auto" outlined>
                <v-virtual-scroll
                  :bench="benched"
                  :items="showCompanies"
                  :height="height"
                  item-height="64"
                >
                  <template v-slot:default="{ item }">
                    <v-list-item :key="item.id" :class="item.lastDraw">
                      <v-list-item-action>
                        <v-checkbox v-model="item.selected"></v-checkbox>
                      </v-list-item-action>
                      <v-list-item-content>
                        <v-list-item-title>
                          {{ item.name }} - <strong>{{ item.status }}</strong>
                        </v-list-item-title>
                      </v-list-item-content>

                      <v-list-item-action>
                        <div>
                          <v-tooltip left>
                            <template v-slot:activator="{ on, attrs }">
                              <v-btn
                                fab
                                dark
                                x-small
                                v-bind="attrs"
                                v-on="on"
                                color="error"
                                class="mr-3"
                                @click="removeCompany(item.id)"
                              >
                                <v-icon>mdi-close</v-icon>
                              </v-btn>
                            </template>
                            <span>Remove Company</span>
                          </v-tooltip>
                          <v-tooltip left>
                            <template v-slot:activator="{ on, attrs }">
                              <v-btn
                                fab
                                dark
                                x-small
                                v-bind="attrs"
                                v-on="on"
                                color="primary"
                                :to="`/company/${item.id}`"
                              >
                                <v-icon>mdi-pencil</v-icon>
                              </v-btn>
                            </template>
                            <span>Edit Company</span>
                          </v-tooltip>
                        </div>
                      </v-list-item-action>
                    </v-list-item>

                    <v-divider></v-divider>
                  </template>
                </v-virtual-scroll>
              </v-card>

              <v-tooltip left>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    class="mx-2"
                    fab
                    dark
                    absolute
                    right
                    color="indigo"
                    style="bottom: 10px;"
                    v-bind="attrs"
                    v-on="on"
                    @click="addCompany()"
                  >
                    <v-icon>mdi-bank-plus</v-icon>
                  </v-btn>
                </template>
                <span>Add Company</span>
              </v-tooltip>
            </v-container>
          </v-sheet>
        </v-card>
      </v-tab-item>
      <v-tab-item>
        <v-card v-resize="onResize">
          <v-app-bar
            absolute
            color="white"
            elevation="0"
            scroll-target="#scrolling-techniques-7"
          >
            <v-checkbox
              v-model="selectAll1"
              :label="numberSelected1"
              @click.stop="selectAllTeam1"
              :indeterminate="indeterminate1"
              hide-details
            ></v-checkbox>

            <v-toolbar-title class="hidden-sm-and-down ml-5">
              {{ consortium.name }}
            </v-toolbar-title>

            <v-progress-linear
              :active="loading"
              :indeterminate1="loading"
              absolute
              bottom
              color="primary"
            ></v-progress-linear>

            <v-spacer></v-spacer>

            <v-tooltip left>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  fab
                  small
                  color="primary"
                  class="hidden-sm-and-down mr-6"
                  v-bind="attrs"
                  v-on="on"
                >
                  <v-icon @click="getPrevious">
                    mdi-account-multiple-check-outline
                  </v-icon>
                </v-btn>
              </template>
              <span>Previous Draws</span>
            </v-tooltip>

            <v-tooltip left>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  fab
                  small
                  color="primary"
                  class="hidden-sm-and-down mr-6"
                  v-bind="attrs"
                  v-on="on"
                >
                  <v-icon @click="getRandom">
                    mdi-selection-ellipse-arrow-inside
                  </v-icon>
                </v-btn>
              </template>
              <span>Random Draw</span>
            </v-tooltip>
          </v-app-bar>

          <v-card>
            <v-row no-gutters>
              <v-col class="cols-12 md-6" order-sm="1">
                <v-sheet
                  v-resize="onResize"
                  :height="height"
                  id="scrolling-techniques-7"
                  class="overflow-y-auto"
                >
                  <!-- <PrevConsortiumList
                    v-if="showDraws"
                    :visible="showDraws"
                    :item="consortium.ConsortiumDraws"
                    @close="closeThis"
                  /> -->
                  <v-container
                    v-if="showDraws"
                    style="margin-top: 70px; margin-bottom: 70px; padding: 0;"
                  >
                    <v-card class="mx-auto" outlined>
                      <h3 v-if="prevDraws.length" class="ml-2">
                        PREVIOUS DRAWS
                      </h3>

                      <v-virtual-scroll
                        :bench="benched"
                        :items="prevDraws"
                        :height="height - 80"
                        item-height="64"
                      >
                        <template v-slot:default="{ item }">
                          <v-list-item :key="item.id" @click="getDraw(item.id)">
                            <v-list-item-content>
                              <v-list-item-title>
                                {{ item.date }}
                              </v-list-item-title>
                            </v-list-item-content>

                            <v-list-item-action>
                              <v-tooltip left>
                                <template v-slot:activator="{ on, attrs }">
                                  <v-btn
                                    icon
                                    color="primary"
                                    class="hidden-sm-and-down mr-6"
                                    v-bind="attrs"
                                    v-on="on"
                                    @click="getDraw(item.id)"
                                  >
                                    <v-icon color="primary">mdi-pencil</v-icon>
                                  </v-btn>
                                </template>
                                <span>Open Draw</span>
                              </v-tooltip>
                            </v-list-item-action>
                          </v-list-item>

                          <v-divider></v-divider>
                        </template>
                      </v-virtual-scroll>
                    </v-card>
                  </v-container>
                  <v-container
                    v-else-if="showDrawP"
                    style="margin-top: 70px; margin-bottom: 70px; padding: 0;"
                  >
                    <v-card class="mx-auto" outlined>
                      <h3 v-if="randomDraw.length" class="ml-2">
                        DRUG
                      </h3>
                      <v-list v-if="randomDraw.length">
                        <template v-for="(employee, index) in randomDraw">
                          <v-lazy :key="index" transition="fade-transition">
                            <v-list-item :class="employee.color">
                              <v-list-item-content class="pl-4 text-left">
                                <v-list-item-title>
                                  {{ employee.companyName }} -
                                  {{ employee.name }}
                                </v-list-item-title>
                              </v-list-item-content>

                              <v-list-item-action>
                                <v-menu>
                                  <template v-slot:activator="{ on }">
                                    <v-btn v-on="on" icon color="primary">
                                      <v-icon>mdi-dots-vertical</v-icon>
                                    </v-btn>
                                  </template>
                                  <v-list dense>
                                    <v-list-item
                                      @click.stop="saveResults(employee)"
                                    >
                                      <v-list-item-title>
                                        Results
                                      </v-list-item-title>
                                      <v-list-item-action>
                                        <v-icon color="primary">
                                          mdi-pencil
                                        </v-icon>
                                      </v-list-item-action>
                                    </v-list-item>
                                    <v-list-item
                                      :to="`/company/${employee.companyId}`"
                                    >
                                      <v-list-item-title>
                                        Go to Company
                                      </v-list-item-title>
                                      <v-list-item-action>
                                        <v-icon color="primary">
                                          mdi-office-building-cog
                                        </v-icon>
                                      </v-list-item-action>
                                    </v-list-item>
                                  </v-list>
                                </v-menu>
                              </v-list-item-action>
                            </v-list-item>
                          </v-lazy>
                          <v-divider
                            v-if="index + 1 < randomDraw.length"
                            :key="`divider-${index}`"
                          ></v-divider>
                        </template>
                      </v-list>
                      <h3 v-if="randomAlcohol.length" class="ml-2">
                        DRUG & ALCOHOL
                      </h3>
                      <v-list v-if="randomAlcohol.length">
                        <template v-for="(employee, index) in randomAlcohol">
                          <v-lazy :key="index" transition="fade-transition">
                            <v-list-item :class="employee.color">
                              <v-list-item-content class="pl-4 text-left">
                                <v-list-item-title>
                                  {{ employee.companyName }} -
                                  {{ employee.name }}
                                </v-list-item-title>
                              </v-list-item-content>

                              <v-list-item-action>
                                <v-menu>
                                  <template v-slot:activator="{ on }">
                                    <v-btn v-on="on" icon color="primary">
                                      <v-icon>mdi-dots-vertical</v-icon>
                                    </v-btn>
                                  </template>
                                  <v-list dense>
                                    <v-list-item
                                      @click.stop="saveResults(employee)"
                                    >
                                      <v-list-item-title>
                                        Results
                                      </v-list-item-title>
                                      <v-list-item-action>
                                        <v-icon color="primary">
                                          mdi-pencil
                                        </v-icon>
                                      </v-list-item-action>
                                    </v-list-item>
                                    <v-list-item
                                      :to="`/company/${employee.companyId}`"
                                    >
                                      <v-list-item-title>
                                        Go to Company
                                      </v-list-item-title>
                                      <v-list-item-action>
                                        <v-icon color="primary">
                                          mdi-office-building-cog
                                        </v-icon>
                                      </v-list-item-action>
                                    </v-list-item>
                                  </v-list>
                                </v-menu>
                              </v-list-item-action>
                            </v-list-item>
                          </v-lazy>
                          <v-divider
                            v-if="index + 1 < randomAlcohol.length"
                            :key="`divider-${index}`"
                          ></v-divider>
                        </template>
                      </v-list>
                    </v-card>
                  </v-container>
                  <v-container v-else style="margin-bottom: 70px; padding: 0;">
                    <v-row
                      style="margin-top: 70px; padding-left: 20px; padding-right: 20px;"
                    >
                      <v-col cols="3" offset="3">
                        <v-text-field
                          v-model="amountDrug"
                          label="Drug Draw"
                          v-mask="drawMask"
                        ></v-text-field>
                      </v-col>
                      <v-col cols="3">
                        <v-text-field
                          v-model="amountAlcohol"
                          label="Drug/Alcohol Draw"
                          v-mask="drawMask"
                        ></v-text-field>
                      </v-col>
                    </v-row>

                    <v-card v-if="showDraw" class="mx-auto" outlined>
                      <h3 v-if="randomDraw.length" class="ml-2">
                        DRUG
                      </h3>
                      <v-list v-if="randomDraw.length">
                        <template v-for="(employee, index) in randomDraw">
                          <v-lazy :key="index" transition="fade-transition">
                            <v-list-item>
                              <v-list-item-content class="pl-4 text-left">
                                <v-list-item-title>
                                  {{ employee.companyName }} -
                                  {{ employee.name }}
                                </v-list-item-title>
                              </v-list-item-content>
                            </v-list-item>
                          </v-lazy>
                          <v-divider
                            v-if="index + 1 < randomDraw.length"
                            :key="`divider-${index}`"
                          ></v-divider>
                        </template>
                      </v-list>
                      <h3 v-if="randomAlcohol.length" class="ml-2">
                        DRUG & ALCOHOL
                      </h3>
                      <v-list v-if="randomAlcohol.length">
                        <template v-for="(employee, index) in randomAlcohol">
                          <v-lazy :key="index" transition="fade-transition">
                            <v-list-item>
                              <v-list-item-content class="pl-4 text-left">
                                <v-list-item-title>
                                  {{ employee.companyName }} -
                                  {{ employee.name }}
                                </v-list-item-title>
                              </v-list-item-content>
                            </v-list-item>
                          </v-lazy>
                          <v-divider
                            v-if="index + 1 < randomAlcohol.length"
                            :key="`divider-${index}`"
                          ></v-divider>
                        </template>
                      </v-list>
                    </v-card>
                  </v-container>
                </v-sheet>
              </v-col>
              <v-col class="cols-12 md-6" order-sm="0">
                <v-sheet
                  v-resize="onResize"
                  :height="height"
                  id="scrolling-techniques-7"
                  class="overflow-y-auto"
                >
                  <v-container
                    style="margin-top: 70px; margin-bottom: 70px; padding: 0;"
                  >
                    <v-card class="mx-auto" outlined>
                      <v-virtual-scroll
                        :bench="benched"
                        :items="showEmployees"
                        :height="height"
                        item-height="64"
                      >
                        <template v-slot:default="{ item }">
                          <v-list-item :key="item.id" :class="item.lastDraw">
                            <v-list-item-action>
                              <v-checkbox v-model="item.selected"></v-checkbox>
                            </v-list-item-action>
                            <v-list-item-content>
                              <v-list-item-title>
                                <strong>{{ item.companyName }}</strong> -
                                {{ item.name }}
                              </v-list-item-title>
                            </v-list-item-content>
                          </v-list-item>

                          <v-divider></v-divider>
                        </template>
                      </v-virtual-scroll>
                    </v-card>
                  </v-container>
                </v-sheet>
              </v-col>
            </v-row>
          </v-card>
        </v-card>

        <v-speed-dial
          if="showDraw"
          v-model="fab"
          dark
          fixed
          right
          color="indigo"
          style="bottom: 80px;"
          direction="top"
          transition="slide-y-reverse-transition"
        >
          <template v-slot:activator>
            <v-btn v-model="fab" color="blue darken-2" dark fab>
              <v-icon v-if="fab">
                mdi-chevron-down
              </v-icon>
              <v-icon v-else>
                mdi-selection-ellipse-arrow-inside
              </v-icon>
            </v-btn>
          </template>

          <v-tooltip left v-if="drawSaved">
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                fab
                dark
                small
                v-bind="attrs"
                v-on="on"
                color="green"
                @click="sendDraw"
              >
                <v-icon>mdi-file-pdf-box</v-icon>
              </v-btn>
            </template>
            <span>Create PDF</span>
          </v-tooltip>
          <v-tooltip left v-if="drawSaved">
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                fab
                dark
                small
                v-bind="attrs"
                v-on="on"
                color="green"
                @click="emailDraw"
              >
                <v-icon>mdi-email</v-icon>
              </v-btn>
            </template>
            <span>Email Draw</span>
          </v-tooltip>
          <v-tooltip left v-if="drawSaved">
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                fab
                dark
                small
                v-bind="attrs"
                v-on="on"
                color="green"
                @click="downloadReport"
              >
                <v-icon>mdi-file-download</v-icon>
              </v-btn>
            </template>
            <span>Download Report</span>
          </v-tooltip>
          <v-tooltip left v-if="!drawSaved">
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                fab
                dark
                small
                v-bind="attrs"
                v-on="on"
                color="green"
                @click="updateDraw"
              >
                <v-icon>mdi-content-save</v-icon>
              </v-btn>
            </template>
            <span>Save Draw</span>
          </v-tooltip>
          <v-tooltip left>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                fab
                dark
                small
                v-bind="attrs"
                v-on="on"
                color="red"
                @click="showDraw = false"
              >
                <v-icon>mdi-close</v-icon>
              </v-btn>
            </template>
            <span>Close</span>
          </v-tooltip>
        </v-speed-dial>
      </v-tab-item>
    </v-tabs>

    <v-dialog v-model="loading1" fullscreen>
      <v-container
        fluid
        fill-height
        style="background-color: rgba(255, 255, 255, 0.5);"
      >
        <v-layout justify-center align-center>
          <v-progress-circular
            :size="70"
            :width="7"
            indeterminate
            color="primary"
          >
          </v-progress-circular>
        </v-layout>
      </v-container>
    </v-dialog>

    <Consortiumform
      :visible="showConsortiumform"
      :item="consortium"
      @close="closeThis"
    />

    <ConsortiumCompany
      :visible="showConsortiumCompany"
      :item="consortium"
      @close="closeThis"
    />

    <Results :visible="showResults" :item="employee" @close="closeResults" />

    <ConfirmDialog ref="confirm" />

    <v-snackbar
      v-model="snackbar.show"
      :color="snackbar.color"
      :multi-line="true"
      :timeout="6000"
    >
      {{ snackbar.message }}
      <v-btn dark text @click="snackbar.show = false">
        Close
      </v-btn>
    </v-snackbar>
  </v-card>
</template>

<script>
import _ from 'lodash'
import Api from '@/services/Api'
import Utilities from '@/services/Utilities'
import moment from 'moment'
import XLSX from 'xlsx'
import { mask } from 'vue-the-mask'

export default {
  name: 'consortium',

  components: {
    Consortiumform: () => import('../components/forms/Consortium'),
    // PrevConsortiumList: () => import('../components/PrevConsortiumList'),
    ConsortiumCompany: () => import('../components/forms/ConsortiumCompany'),
    Results: () => import('../components/forms/Results'),
    ConfirmDialog: () => import('../components/forms/ConfirmDialog'),
  },

  directives: {
    mask,
  },

  data() {
    return {
      showConsortiumform: false,
      showConsortiumCompany: false,
      amountDrug: 0,
      amountAlcohol: 0,
      benched: 0,
      companies: [],
      consortium: {},
      consortiumDrawId: 0,
      consortiumId: 0,
      contentHeight: 0,
      currentPage: 'Consortium',
      dialog: false,
      drawId: 0,
      drawList: [],
      drawMask: '###',
      drawSaved: false,
      employees: [],
      employee: {},
      fab: false,
      height: 400,
      indeterminate: false,
      indeterminate1: false,
      loading: true,
      loading1: false,
      messages: [],
      newDraw: null,
      numberSelected: 'Select All',
      numberSelected1: 'Select All',
      prevDraws: [],
      prevDraw: {},
      randomDraw: [],
      randomAlcohol: [],
      selected: {},
      selected1: {},
      selectAll: true,
      selectAll1: true,
      search: '',
      showCompanies: [],
      showDraw: false,
      showDraws: false,
      showDrawP: false,
      showEmployees: [],
      showResults: false,
      snackbar: {
        show: false,
        color: '',
        message: '',
      },
      viewDialog: false,
    }
  },

  created() {
    this.consortiumId = this.$route.params.id
    // console.log(this.consortiumId)

    this.getConsortium()
    this.getCompanies()
  },

  mounted() {
    this.onResize()
  },

  watch: {
    showCompanies: {
      // eslint-disable-next-line
      handler: function (val, oldVal) {
        // this.loading = true
        this.selected = _.filter(this.showCompanies, ['selected', true])

        const notSelected = _.filter(this.showCompanies, ['selected', false])

        if (this.selected === undefined || this.selected.length == 0) {
          this.indeterminate = false
          this.selectAll = false
        } else {
          if (notSelected === undefined || notSelected.length == 0) {
            this.selectAll = true
          } else {
            this.selectAll = false
          }

          if (!this.selectAll) {
            this.indeterminate = true
          }
        }

        if (this.selected.length > 0) {
          this.numberSelected = '(' + this.selected.length + ' selected)'
          this.disable = false
        } else {
          this.numberSelected = 'Select All'
          this.disable = true
        }

        this.loading = false
      },
      deep: true,
    },

    showEmployees: {
      // eslint-disable-next-line
      handler: function (val, oldVal) {
        // this.loading = true
        this.selected1 = _.filter(this.showEmployees, ['selected', true])

        const notSelected = _.filter(this.showEmployees, ['selected', false])

        if (this.selected === undefined || this.selected1.length == 0) {
          this.indeterminate1 = false
          this.selectAll1 = false
        } else {
          if (notSelected === undefined || notSelected.length == 0) {
            this.selectAll1 = true
          } else {
            this.selectAll1 = false
          }

          if (!this.selectAll1) {
            this.indeterminate1 = true
          }
        }

        if (this.selected.length > 0) {
          this.numberSelected1 = '(' + this.selected1.length + ' selected)'
          this.disable = false
        } else {
          this.numberSelected1 = 'Select All'
          this.disable = true
        }

        this.loading = false
      },
      deep: true,
    },
  },

  methods: {
    onResize() {
      this.height = window.innerHeight - 190
    },

    async getConsortium() {
      try {
        const response = await Api().get('consortium/' + this.consortiumId)

        const consortium = response.data

        this.consortium = consortium

        this.loading = false
      } catch (e) {
        console.error(e)
      }
    },

    editConsortium() {
      this.showConsortiumform = true
    },

    addCompany() {
      this.showConsortiumCompany = true
    },

    closeThis() {
      this.showConsortiumform = false
      this.showConsortiumCompany = false
      this.showResults = false
      this.showEmployees = []
      this.drawList = []
      this.getCompanies()
    },

    closeResults() {
      this.showResults = false
      this.randomDraw = []
      this.randomAlcohol = []

      this.getDraw(this.consortiumDrawId)
    },

    async getCompanies() {
      try {
        const response = await Api().get(
          'consortium_companys/' + this.consortiumId
        )

        const companies = response.data

        for (let k in companies) {
          companies[k].selected = true

          let firstTime = true
          companies[k].emailTo = ''

          for (let j in companies[k].Contacts) {
            if (companies[k].Contacts[j].active === 'Yes') {
              if (!firstTime) {
                companies[k].emailTo += ', '
              } else {
                firstTime = false
              }

              companies[k].emailTo += companies[k].Contacts[j].email
            }
          }

          this.getEmployees(
            companies[k].id,
            companies[k].name,
            companies[k].emailTo
          )

          let test = this.showEmployees.sort((a, b) => {
            let fa = a.companyName.toLowerCase(),
              fb = b.companyName.toLowerCase()

            if (fa < fb) {
              return -1
            }
            if (fa > fb) {
              return 1
            }

            return 0
          })

          this.showEmployees = test

          this.drawList.push(companies[k])
        }

        this.showCompanies = this.drawList
        this.loading = false
      } catch (e) {
        console.error(e)
      }
    },

    async getEmployees(companyId, companyName, companyEmail) {
      try {
        const response = await Api().get('employees/' + companyId)
        const employees = response.data

        let row = {}
        let lastDraw = ''
        let draw = {}
        let draws = []

        for (let i in this.consortium.ConsortiumDraws) {
          this.drawId = this.consortium.ConsortiumDraws[i].id
        }

        for (let i in employees) {
          row['id'] = employees[i].id
          row['companyId'] = companyId
          row['companyName'] = companyName
          row['companyEmail'] = companyEmail
          row['name'] = employees[i].name
          row['firstName'] = employees[i].firstName
          row['lastName'] = employees[i].lastName
          row['active'] = employees[i].active

          for (let j in employees[i].ConsortiumDraws) {
            if (this.drawId === employees[i].ConsortiumDraws[j].id) {
              lastDraw = 'red lighten-4'
            }

            draw['id'] = employees[i].ConsortiumDraws[j].id

            draw['date'] = moment(
              employees[i].ConsortiumDraws[j].createdAt
            ).format('MM/DD/YYYY h:mm:ss a')

            draw['title'] =
              employees[i].ConsortiumDraws[j].EmployeeConsortiumDraw.title

            draws.push(draw)
            draw = {}
          }

          row['draws'] = draws
          row['lastDraw'] = lastDraw
          row['selected'] = true

          this.employees.push(row)
          row = {}
          draws = []
          lastDraw = ''
        }

        this.employees.sort(function(a, b) {
          var nameA = a.companyName.toUpperCase()
          var nameB = b.companyName.toUpperCase()
          if (nameA < nameB) {
            return -1
          }
          if (nameA > nameB) {
            return 1
          }

          return 0
        })

        this.showEmployees = this.employees
      } catch (e) {
        console.error(e)
      }
    },

    async getPrevious() {
      try {
        this.prevDraws = []
        this.loading1 = true
        this.showDraws = true
        this.showDrawp = false
        let draw = {}

        for (let i in this.consortium.ConsortiumDraws) {
          draw.id = this.consortium.ConsortiumDraws[i].id

          draw.date = moment(
            this.consortium.ConsortiumDraws[i].createdAt
          ).format('MM/DD/YYYY h:mm:ss a')

          this.prevDraws.push(draw)
          draw = {}
        }

        this.loading1 = false
      } catch (e) {
        console.error(e)
      }
    },

    async getDraw(id) {
      try {
        this.loading1 = true
        this.showDraws = false
        this.showDrawP = true
        this.drawSaved = true
        let drawinfo = {}
        this.randomDraw = []
        this.randomAlcohol = []

        this.consortiumDrawId = id
        console.log('start draw')

        const response = await Api().get('consortium_draw/' + id)

        const draw = response.data
        console.log('draw downloaded', draw)

        for (let i in draw.Employees) {
          let company = this.drawList.find(
            ({ id }) => id === draw.Employees[i].CompanyId
          )

          // if (company.Contacts && company.Contacts.length > 0) {
          //   let contacts = company.Contacts

          //   let firstTime = true
          //   drawinfo.companyEmail = ''

          //   for (let j in contacts) {
          //     if (contacts[j].active === 'Yes') {
          //       if (!firstTime) {
          //         drawinfo.companyEmail += ', '
          //       } else {
          //         firstTime = false
          //       }

          //       drawinfo.companyEmail += contacts[j].email
          //     }
          //   }
          // }

          drawinfo.active = 'Yes'
          drawinfo.color = 'white'
          drawinfo.id = draw.Employees[i].id
          drawinfo.companyId = company.id
          drawinfo.companyName = company.name
          drawinfo.companyEmail = company.emailTo
          drawinfo.firstName = draw.Employees[i].firstName
          drawinfo.lastName = draw.Employees[i].lastName
          drawinfo.name = draw.Employees[i].name
          drawinfo.filePathDrug =
            draw.Employees[i].EmployeeConsortiumDraw.filePath +
            draw.Employees[i].EmployeeConsortiumDraw.drugFile
          drawinfo.filePathAlcohol =
            draw.Employees[i].EmployeeConsortiumDraw.filePath +
            draw.Employees[i].EmployeeConsortiumDraw.alcoholFile
          drawinfo.consortiumDrawId = id
          drawinfo.drugStatus =
            draw.Employees[i].EmployeeConsortiumDraw.drugStatus
          drawinfo.drugDate = Utilities.displayDate(
            draw.Employees[i].EmployeeConsortiumDraw.drugDate
          )
          drawinfo.drugFile = draw.Employees[i].EmployeeConsortiumDraw.drugFile
          drawinfo.drugFile1 = null
          drawinfo.drugNotes =
            draw.Employees[i].EmployeeConsortiumDraw.drugNotes
          drawinfo.alcoholStatus =
            draw.Employees[i].EmployeeConsortiumDraw.alcoholStatus
          drawinfo.alcoholDate = Utilities.displayDate(
            draw.Employees[i].EmployeeConsortiumDraw.alcoholDate
          )
          drawinfo.alcoholFile =
            draw.Employees[i].EmployeeConsortiumDraw.alcoholFile
          drawinfo.alcoholFile1 = null
          drawinfo.alcoholNotes =
            draw.Employees[i].EmployeeConsortiumDraw.alcoholNotes

          if (draw.Employees[i].EmployeeConsortiumDraw.title === 'Drug') {
            drawinfo.type = 'd1'

            if (drawinfo.drugStatus === 'Invalid') {
              drawinfo.color = 'red accent-2'
            } else if (drawinfo.drugStatus === 'Fail') {
              drawinfo.color = 'orange'
            } else if (drawinfo.drugStatus === 'Pass') {
              drawinfo.color = 'green'
            }

            this.randomDraw.push(drawinfo)
          } else {
            drawinfo.type = 'd2'

            if (drawinfo.drugStatus === 'Invalid') {
              drawinfo.color = 'red accent-2'
            } else if (
              drawinfo.drugStatus === 'Fail' ||
              drawinfo.alcoholStatus === 'Fail'
            ) {
              drawinfo.color = 'orange'
            } else if (
              drawinfo.drugStatus === 'Pass' &&
              drawinfo.alcoholStatus === 'Pass'
            ) {
              drawinfo.color = 'green'
            } else if (
              drawinfo.drugStatus === 'Pass' ||
              drawinfo.alcoholStatus === 'Pass'
            ) {
              drawinfo.color = 'green lighten-4'
            }

            this.randomAlcohol.push(drawinfo)
          }
          drawinfo = {}
        }
        console.log('draw done')

        this.prevDraw = draw
        this.loading1 = false
      } catch (e) {
        console.error(e)
      }
    },

    getRandom() {
      this.showDraw = true
      this.showDraws = false
      this.showDrawP = false
      this.drawSaved = false

      var drawList = this.selected1.map(obj => ({ ...obj }))
      // console.log(drawList, this.amountDrug, this.amountAlcohol)

      if (drawList.length < this.amountDrug) {
        this.snackbar.message = 'There are more draws then there are employees!'
        this.snackbar.color = 'error'
        this.snackbar.show = true
        return
      }

      this.randomDraw = []
      this.randomAlcohol = []

      var random = []
      var randomAlcohol = []

      for (var i = 0; i < this.amountDrug; i++) {
        var shuffled = drawList[Math.floor(Math.random() * drawList.length)]
        shuffled.type = 'd1'

        random.push(shuffled)

        _.remove(drawList, function(e) {
          return e.id === shuffled.id
        })
      }

      for (var j = 0; j < this.amountAlcohol; j++) {
        var alcohol = random[Math.floor(Math.random() * random.length)]
        alcohol.type = 'd2'

        randomAlcohol.push(alcohol)

        _.remove(random, function(e) {
          return e.id === alcohol.id
        })
      }

      this.randomDraw = random
      this.randomAlcohol = randomAlcohol
    },

    async updateDraw() {
      let currentDate = moment().format('MM/DD/YYYY h:mm:ss a')
      let printDate = moment().format('YYYY-MM-DD')

      let drug = this.amountDrug - this.amountAlcohol
      let amount = this.showEmployees.length

      try {
        let draw = {}
        draw.currentDate = currentDate
        draw.printDate = printDate
        draw.drug = drug
        draw.amount = amount
        draw.amountAlcohol = this.amountAlcohol
        draw.emailId = this.contactId
        draw.email = this.emailTo
        draw.consortium = this.consortium
        draw.randomDraw = this.randomDraw
        draw.randomAlcohol = this.randomAlcohol
        draw.userId = this.$store.state.user.id

        const response = await Api().post('save_consortium_draw', draw)
        this.drawSaved = true
        this.newDraw = response.data

        this.snackbar.message = response.data.message
        this.snackbar.color = 'success'
        this.snackbar.show = true
      } catch (e) {
        this.snackbar.message = e.response.data.error
        this.snackbar.color = 'error'
        this.snackbar.show = true
      }
    },

    async sendDraw() {
      let currentDate = moment().format('MM/DD/YYYY h:mm:ss a')
      let printDate = moment().format('YYYY-MM-DD')

      let drug = this.amountDrug - this.amountAlcohol
      let amount = this.showEmployees.length

      try {
        let draw = {}
        draw.currentDate = currentDate
        draw.printDate = printDate
        draw.drug = drug
        draw.amount = amount
        draw.amountAlcohol = this.amountAlcohol
        draw.emailId = this.contactId
        draw.email = this.emailTo
        draw.consortium = this.consortium
        draw.random = this.random
        draw.randomDraw = this.randomDraw
        draw.randomAlcohol = this.randomAlcohol
        draw.userId = this.$store.state.user.id

        const response = await Api().post('print_consortium_pdf', draw)

        this.snackbar.message = response.data.message
        this.snackbar.color = 'success'
        this.snackbar.show = true
      } catch (e) {
        this.snackbar.message = e.response.data.error
        this.snackbar.color = 'error'
        this.snackbar.show = true
      }
    },

    async emailDraw() {
      let currentDate = moment().format('MM/DD/YYYY h:mm:ss a')
      let printDate = moment().format('YYYY-MM-DD')

      let drug = this.amountDrug - this.amountAlcohol
      let amount = this.showEmployees.length

      try {
        let draw = {}
        draw.currentDate = currentDate
        draw.printDate = printDate
        draw.drug = drug
        draw.amount = amount
        draw.amountAlcohol = this.amountAlcohol
        draw.emailId = this.contactId
        draw.email = this.emailTo
        draw.consortium = this.consortium
        draw.random = this.random
        draw.randomDraw = this.randomDraw
        draw.randomAlcohol = this.randomAlcohol
        draw.userId = this.$store.state.user.id

        const response = await Api().post('email_consortium_pdf', draw)

        this.snackbar.message = response.data.message
        this.snackbar.color = 'success'
        this.snackbar.show = true
      } catch (e) {
        this.snackbar.message = e.response.data.err
        this.snackbar.color = 'error'
        this.snackbar.show = true
      }
    },

    async sendExport() {
      this.loading1 = true
      try {
        // console.log('companies', this.selected)
        let formData = {}
        formData.companies = this.selected
        formData.userId = this.$store.state.user.id

        const response = await Api().post('send_consortium_lists/', formData)

        this.loading1 = false
        this.snackbar.message = response.data.message
        this.snackbar.color = 'success'
        this.snackbar.show = true
      } catch (e) {
        this.snackbar.message = e.response.data.error
        this.snackbar.color = 'error'
        this.snackbar.show = true
      }
    },

    async downloadReport() {
      this.loading1 = true
      try {
        console.log(this.newDraw.draw.id)
        const response = await Api().get(
          'consortium_report/' + this.newDraw.draw.id
        )

        let membersWS = XLSX.utils.json_to_sheet(response.data)

        let wb = XLSX.utils.book_new()

        XLSX.utils.book_append_sheet(wb, membersWS, 'Consortium')

        XLSX.writeFile(wb, this.consortium.name + '.csv')
        // XLSX.writeFile(test, this.companyName + '.xlsx')

        this.loading1 = false
        this.snackbar.message = 'Report Generated.'
        this.snackbar.color = 'success'
        this.snackbar.show = true
      } catch (e) {
        this.loading1 = false
        this.snackbar.message = e.response.data.error
        this.snackbar.color = 'error'
        this.snackbar.show = true
      }
    },

    selectAllTeam() {
      if (this.indeterminate) {
        this.indeterminate = false
        this.selectAll = true
      }

      for (var i in this.showCompanies) {
        this.showCompanies[i].selected = this.selectAll
      }
    },

    selectAllTeam1() {
      if (this.indeterminate1) {
        this.indeterminate1 = false
        this.selectAll1 = true
      }

      for (var i in this.showEmployees) {
        this.showEmployees[i].selected = this.selectAll1
      }
    },

    saveResults(employee) {
      employee.consortiumId = this.consortium.id
      this.employee = employee
      this.showResults = true
    },

    async removeCompany(companyId) {
      if (
        await this.$refs.confirm.open(
          'Confirm',
          'Are you sure you want to delete this record?'
        )
      ) {
        this.deleteRecord(companyId)
      }
    },

    async deleteRecord(companyId) {
      try {
        let formData = {}
        formData.ConsortiumId = 0

        const response = await Api().put('companies/' + companyId, formData)

        this.showEmployees = []
        this.drawList = []
        this.getCompanies()

        this.snackbar.message = response.data.message
        this.snackbar.color = 'success'
        this.snackbar.show = true
      } catch (e) {
        this.snackbar.message = e.response.data.error
        this.snackbar.color = 'error'
        this.snackbar.show = true
      }
    },
  },
}
</script>

<style scoped></style>
